import {
  LOAN_LOADING,
  GET_LOAN,
  GET_LOAN_SUCCESS,
  GET_LOAN_FAIL,
  ADD_LOAN_SUCCESS,
  ADD_LOAN_FAIL,
  DELETE_LOAN_SUCCESS,
  DELETE_LOAN_FAIL,
  UPDATE_LOAN_SUCCESS,
  UPDATE_LOAN_FAIL,
  LOAN_RESET
} from "./actionType";

const INIT_STATE = {
  loans: [],
  error: {},
};

const Loan = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LOAN_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LOAN:
          return {
            ...state,
            loans: action.payload.data,
            isLoanCreated: false,
            isLoanSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LOAN_FAIL:
      switch (action.payload.actionType) {
        case GET_LOAN_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLoanCreated: false,
            isLoanSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LOAN: {
      return {
        ...state,
        isLoanCreated: false,
        loading: true,
      };
    }

    case LOAN_LOADING: {
      return {
        ...state,
        isLoanCreated: false,
        loading: true,
      };
    }

    case ADD_LOAN_SUCCESS:
      return {
        ...state,
        isLoanCreated: true,
        loading: false,
        loans: [action.payload.data, ...state.loans],
      };

    case ADD_LOAN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LOAN_SUCCESS:
      return {
        ...state,
        loading: false,
        isLoanCreated: true,
        loans: state.loans.filter(
          loan => loan.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LOAN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LOAN_SUCCESS:
      return {
        ...state,
        loading: false,
        isLoanCreated: true,
        loans: state.loans.map(loan =>
          loan.id.toString() === action.payload.data.id.toString() ? { ...loan, ...action.payload.data } : loan
        ),
      };

    case UPDATE_LOAN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LOAN_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Loan;